(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire44e7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire44e7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hvZMf", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $cc05409771aeea55$export$71511d61b312f219; });

var $2zPWk = parcelRequire("2zPWk");

var $91t4N = parcelRequire("91t4N");

var $eTJIp = parcelRequire("eTJIp");

var $537SV = parcelRequire("537SV");
function $cc05409771aeea55$export$71511d61b312f219(arr) {
    return (0, $2zPWk._)(arr) || (0, $91t4N._)(arr) || (0, $537SV._)(arr) || (0, $eTJIp._)();
}

});
parcelRegister("2zPWk", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $1e0723cca33e235d$export$71511d61b312f219; });

var $a3d64 = parcelRequire("a3d64");
function $1e0723cca33e235d$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $a3d64._)(arr);
}

});
parcelRegister("a3d64", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $751457f6259d374a$export$71511d61b312f219; });
function $751457f6259d374a$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRegister("91t4N", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $691ac3035b950bbe$export$71511d61b312f219; });
function $691ac3035b950bbe$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("eTJIp", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $ad89a9d214926ab2$export$71511d61b312f219; });
function $ad89a9d214926ab2$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("537SV", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $3ad35952737de5da$export$71511d61b312f219; });

var $a3d64 = parcelRequire("a3d64");
function $3ad35952737de5da$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $a3d64._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $a3d64._)(o, minLen);
}

});


parcelRegister("LCZef", function(module, exports) {

$parcel$export(module.exports, "show", function () { return $5e37999a99b848cc$export$57bf213be019eeb0; });
$parcel$export(module.exports, "hide", function () { return $5e37999a99b848cc$export$fe8985bb6374093c; });
$parcel$export(module.exports, "fadeIn", function () { return $5e37999a99b848cc$export$82e6205b15e6c637; });
$parcel$export(module.exports, "fadeOut", function () { return $5e37999a99b848cc$export$c091916f1530334c; });
$parcel$export(module.exports, "slideUp", function () { return $5e37999a99b848cc$export$deed561b1a0ff1ea; });
$parcel$export(module.exports, "slideDown", function () { return $5e37999a99b848cc$export$abdd11a06a163232; });
$parcel$export(module.exports, "slideIn", function () { return $5e37999a99b848cc$export$d08c54023c399c9c; });
$parcel$export(module.exports, "slideOut", function () { return $5e37999a99b848cc$export$388d063d19975bb; });
$parcel$export(module.exports, "isVisible", function () { return $5e37999a99b848cc$export$795910f5f15a9633; });

var $hvZMf = parcelRequire("hvZMf");
var $5e37999a99b848cc$export$57bf213be019eeb0 = function(element, options) {
    if (element) {
        var _element_classList, _element_classList1;
        element.style.removeProperty('display');
        var display = window.getComputedStyle(element).display;
        element.style.display = display === 'none' ? 'block' : display;
        (options === null || options === void 0 ? void 0 : options.addClasses) && (_element_classList = element.classList).add.apply(_element_classList, (0, $hvZMf._)(options.addClasses));
        (options === null || options === void 0 ? void 0 : options.removeClasses) && (_element_classList1 = element.classList).remove.apply(_element_classList1, (0, $hvZMf._)(options.removeClasses));
        element.offsetHeight;
    }
};
var $5e37999a99b848cc$export$fe8985bb6374093c = function(element, options) {
    if (element) {
        var _element_classList, _element_classList1;
        element.style.display = 'none';
        (options === null || options === void 0 ? void 0 : options.addClasses) && (_element_classList = element.classList).add.apply(_element_classList, (0, $hvZMf._)(options.addClasses));
        (options === null || options === void 0 ? void 0 : options.removeClasses) && (_element_classList1 = element.classList).remove.apply(_element_classList1, (0, $hvZMf._)(options.removeClasses));
    }
};
var $5e37999a99b848cc$export$82e6205b15e6c637 = function(element) {
    var duration = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 200, options = arguments.length > 2 ? arguments[2] : void 0;
    if (element && ((options === null || options === void 0 ? void 0 : options.animateOnlyIfToggled) === undefined || (options === null || options === void 0 ? void 0 : options.animateOnlyIfToggled) && window.getComputedStyle(element).display === 'none')) {
        var _element_classList, _element_classList1;
        element.style.removeProperty('display');
        var display = window.getComputedStyle(element).display;
        element.style.opacity = '0';
        element.style.visibility = 'hidden';
        element.style.display = display === 'none' ? 'block' : display;
        // Force CSS Reflow
        element.offsetHeight;
        element.style.transition = "opacity ".concat(duration, "ms linear");
        element.style.visibility = 'visible';
        element.style.opacity = '1';
        if ((options === null || options === void 0 ? void 0 : options.addClasses) && !options.addClassesAfterDuration) (_element_classList = element.classList).add.apply(_element_classList, (0, $hvZMf._)(options.addClasses));
        if ((options === null || options === void 0 ? void 0 : options.removeClasses) && !options.removeClassesAfterDuration) (_element_classList1 = element.classList).remove.apply(_element_classList1, (0, $hvZMf._)(options.removeClasses));
        setTimeout(function() {
            var _element_classList, _element_classList1;
            var _options_callback;
            element.style.removeProperty('opacity');
            element.style.removeProperty('visibility');
            element.style.removeProperty('transition');
            options === null || options === void 0 ? void 0 : (_options_callback = options.callback) === null || _options_callback === void 0 ? void 0 : _options_callback.call(options);
            if ((options === null || options === void 0 ? void 0 : options.addClasses) && options.addClassesAfterDuration) (_element_classList = element.classList).add.apply(_element_classList, (0, $hvZMf._)(options.addClasses));
            if ((options === null || options === void 0 ? void 0 : options.removeClasses) && options.removeClassesAfterDuration) (_element_classList1 = element.classList).remove.apply(_element_classList1, (0, $hvZMf._)(options.removeClasses));
        }, duration);
    }
};
var $5e37999a99b848cc$export$c091916f1530334c = function(element) {
    var duration = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 200, options = arguments.length > 2 ? arguments[2] : void 0;
    if (element && ((options === null || options === void 0 ? void 0 : options.animateOnlyIfToggled) === undefined || (options === null || options === void 0 ? void 0 : options.animateOnlyIfToggled) && window.getComputedStyle(element).display !== 'none')) {
        var _element_classList, _element_classList1;
        element.style.transition = "opacity ".concat(duration, "ms linear");
        element.style.opacity = '0';
        // Force CSS Reflow
        element.offsetHeight;
        if ((options === null || options === void 0 ? void 0 : options.addClasses) && !options.addClassesAfterDuration) (_element_classList = element.classList).add.apply(_element_classList, (0, $hvZMf._)(options.addClasses));
        if ((options === null || options === void 0 ? void 0 : options.removeClasses) && !options.removeClassesAfterDuration) (_element_classList1 = element.classList).remove.apply(_element_classList1, (0, $hvZMf._)(options.removeClasses));
        setTimeout(function() {
            var _element_classList, _element_classList1;
            var _options_callback;
            element.style.display = 'none';
            element.style.removeProperty('transition');
            element.style.removeProperty('opacity');
            options === null || options === void 0 ? void 0 : (_options_callback = options.callback) === null || _options_callback === void 0 ? void 0 : _options_callback.call(options);
            if ((options === null || options === void 0 ? void 0 : options.addClasses) && options.addClassesAfterDuration) (_element_classList = element.classList).add.apply(_element_classList, (0, $hvZMf._)(options.addClasses));
            if ((options === null || options === void 0 ? void 0 : options.removeClasses) && options.removeClassesAfterDuration) (_element_classList1 = element.classList).remove.apply(_element_classList1, (0, $hvZMf._)(options.removeClasses));
        }, duration);
    }
};
var $5e37999a99b848cc$export$75d3d2c72ecccf9b = function(element) {
    var duration = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 200, options = arguments.length > 2 ? arguments[2] : void 0;
    if (element) {
        if (window.getComputedStyle(element).display === 'none') return $5e37999a99b848cc$export$82e6205b15e6c637(element, duration, options);
        else return $5e37999a99b848cc$export$c091916f1530334c(element, duration, options);
    }
};
var $5e37999a99b848cc$export$deed561b1a0ff1ea = function(element) {
    var duration = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 200, options = arguments.length > 2 ? arguments[2] : void 0;
    if (element) {
        var _element_classList, _element_classList1;
        element.style.transitionProperty = 'height, margin, padding';
        element.style.transitionDuration = duration + 'ms';
        element.style.height = element.offsetHeight + 'px';
        // Force CSS Reflow
        element.offsetHeight;
        element.style.overflow = 'hidden';
        element.style.height = '0';
        element.style.paddingTop = '0';
        element.style.paddingBottom = '0';
        element.style.marginTop = '0';
        element.style.marginBottom = '0';
        if ((options === null || options === void 0 ? void 0 : options.addClasses) && !options.addClassesAfterDuration) (_element_classList = element.classList).add.apply(_element_classList, (0, $hvZMf._)(options.addClasses));
        if ((options === null || options === void 0 ? void 0 : options.removeClasses) && !options.removeClassesAfterDuration) (_element_classList1 = element.classList).remove.apply(_element_classList1, (0, $hvZMf._)(options.removeClasses));
        setTimeout(function() {
            var _element_classList, _element_classList1;
            var _options_callback;
            element.style.display = 'none';
            element.style.removeProperty('height');
            element.style.removeProperty('padding-top');
            element.style.removeProperty('padding-bottom');
            element.style.removeProperty('margin-top');
            element.style.removeProperty('margin-bottom');
            element.style.removeProperty('overflow');
            element.style.removeProperty('transition-duration');
            element.style.removeProperty('transition-property');
            options === null || options === void 0 ? void 0 : (_options_callback = options.callback) === null || _options_callback === void 0 ? void 0 : _options_callback.call(options);
            if ((options === null || options === void 0 ? void 0 : options.addClasses) && options.addClassesAfterDuration) (_element_classList = element.classList).add.apply(_element_classList, (0, $hvZMf._)(options.addClasses));
            if ((options === null || options === void 0 ? void 0 : options.removeClasses) && options.removeClassesAfterDuration) (_element_classList1 = element.classList).remove.apply(_element_classList1, (0, $hvZMf._)(options.removeClasses));
        }, duration);
    }
};
var $5e37999a99b848cc$export$abdd11a06a163232 = function(element) {
    var duration = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 200, options = arguments.length > 2 ? arguments[2] : void 0;
    if (element) {
        var _element_classList, _element_classList1;
        element.style.removeProperty('display');
        var display = window.getComputedStyle(element).display;
        element.style.display = display === 'none' ? 'block' : display;
        var height = element.offsetHeight;
        element.style.overflow = 'hidden';
        element.style.height = '0';
        element.style.paddingTop = '0';
        element.style.paddingBottom = '0';
        element.style.marginTop = '0';
        element.style.marginBottom = '0';
        // Force CSS Reflow
        element.offsetHeight;
        element.style.boxSizing = 'border-box';
        element.style.transitionProperty = 'height, margin, padding';
        element.style.transitionDuration = duration + 'ms';
        element.style.height = height + 'px';
        element.style.removeProperty('padding-top');
        element.style.removeProperty('padding-bottom');
        element.style.removeProperty('margin-top');
        element.style.removeProperty('margin-bottom');
        if ((options === null || options === void 0 ? void 0 : options.addClasses) && !options.addClassesAfterDuration) (_element_classList = element.classList).add.apply(_element_classList, (0, $hvZMf._)(options.addClasses));
        if ((options === null || options === void 0 ? void 0 : options.removeClasses) && !options.removeClassesAfterDuration) (_element_classList1 = element.classList).remove.apply(_element_classList1, (0, $hvZMf._)(options.removeClasses));
        setTimeout(function() {
            var _element_classList, _element_classList1;
            var _options_callback;
            element.style.removeProperty('height');
            element.style.removeProperty('overflow');
            element.style.removeProperty('transition-duration');
            element.style.removeProperty('transition-property');
            options === null || options === void 0 ? void 0 : (_options_callback = options.callback) === null || _options_callback === void 0 ? void 0 : _options_callback.call(options);
            if ((options === null || options === void 0 ? void 0 : options.addClasses) && options.addClassesAfterDuration) (_element_classList = element.classList).add.apply(_element_classList, (0, $hvZMf._)(options.addClasses));
            if ((options === null || options === void 0 ? void 0 : options.removeClasses) && options.removeClassesAfterDuration) (_element_classList1 = element.classList).remove.apply(_element_classList1, (0, $hvZMf._)(options.removeClasses));
        }, duration);
    }
};
var $5e37999a99b848cc$export$715de50cedc228a8 = function(element) {
    var duration = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 200, options = arguments.length > 2 ? arguments[2] : void 0;
    if (element) {
        if (window.getComputedStyle(element).display === 'none') return $5e37999a99b848cc$export$abdd11a06a163232(element, duration, options);
        else return $5e37999a99b848cc$export$deed561b1a0ff1ea(element, duration, options);
    }
};
var $5e37999a99b848cc$export$d08c54023c399c9c = function(element) {
    var duration = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 300, options = arguments.length > 2 ? arguments[2] : void 0;
    if (element) {
        var _element_classList, _element_classList1;
        element.style.removeProperty('display');
        var display = window.getComputedStyle(element).display;
        element.style.left = "-".concat(element.offsetWidth, "px");
        element.style.display = 'none';
        element.style.removeProperty('display');
        element.style.left = "-".concat(element.offsetWidth, "px");
        element.style.display = display === 'none' ? 'block' : display;
        element.style.transitionProperty = 'left';
        element.style.transitionDuration = duration + 'ms';
        element.style.left = (options === null || options === void 0 ? void 0 : options.distance) !== undefined ? "".concat(options.distance, "px") : '';
        document.documentElement.classList.add('mobile-behind');
        if ((options === null || options === void 0 ? void 0 : options.addClasses) && !options.addClassesAfterDuration) (_element_classList = element.classList).add.apply(_element_classList, (0, $hvZMf._)(options.addClasses));
        if ((options === null || options === void 0 ? void 0 : options.removeClasses) && !options.removeClassesAfterDuration) (_element_classList1 = element.classList).remove.apply(_element_classList1, (0, $hvZMf._)(options.removeClasses));
        setTimeout(function() {
            var _element_classList, _element_classList1;
            var _element_querySelector, _options_callback;
            element.style.removeProperty('transition-duration');
            element.style.removeProperty('transition-property');
            (_element_querySelector = element.querySelector('a, button')) === null || _element_querySelector === void 0 ? void 0 : _element_querySelector.focus();
            options === null || options === void 0 ? void 0 : (_options_callback = options.callback) === null || _options_callback === void 0 ? void 0 : _options_callback.call(options);
            if ((options === null || options === void 0 ? void 0 : options.addClasses) && options.addClassesAfterDuration) (_element_classList = element.classList).add.apply(_element_classList, (0, $hvZMf._)(options.addClasses));
            if ((options === null || options === void 0 ? void 0 : options.removeClasses) && options.removeClassesAfterDuration) (_element_classList1 = element.classList).remove.apply(_element_classList1, (0, $hvZMf._)(options.removeClasses));
        }, duration);
    }
};
var $5e37999a99b848cc$export$388d063d19975bb = function(element) {
    var duration = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 300, options = arguments.length > 2 ? arguments[2] : void 0;
    if (element) {
        var _element_classList, _element_classList1;
        var distance = "-".concat(window.getComputedStyle(element).width);
        element.style.transitionProperty = 'left';
        element.style.transitionDuration = duration + 'ms';
        element.style.left = distance;
        document.documentElement.classList.remove('mobile-behind');
        if ((options === null || options === void 0 ? void 0 : options.addClasses) && !options.addClassesAfterDuration) (_element_classList = element.classList).add.apply(_element_classList, (0, $hvZMf._)(options.addClasses));
        if ((options === null || options === void 0 ? void 0 : options.removeClasses) && !options.removeClassesAfterDuration) (_element_classList1 = element.classList).remove.apply(_element_classList1, (0, $hvZMf._)(options.removeClasses));
        setTimeout(function() {
            var _element_classList, _element_classList1;
            var _options_toggle, _options_callback;
            element.style.removeProperty('transition-duration');
            element.style.removeProperty('transition-property');
            element.style.display = 'none';
            options === null || options === void 0 ? void 0 : (_options_toggle = options.toggle) === null || _options_toggle === void 0 ? void 0 : _options_toggle.focus();
            options === null || options === void 0 ? void 0 : (_options_callback = options.callback) === null || _options_callback === void 0 ? void 0 : _options_callback.call(options);
            if ((options === null || options === void 0 ? void 0 : options.addClasses) && options.addClassesAfterDuration) (_element_classList = element.classList).add.apply(_element_classList, (0, $hvZMf._)(options.addClasses));
            if ((options === null || options === void 0 ? void 0 : options.removeClasses) && options.removeClassesAfterDuration) (_element_classList1 = element.classList).remove.apply(_element_classList1, (0, $hvZMf._)(options.removeClasses));
        }, duration);
    }
};
var $5e37999a99b848cc$export$795910f5f15a9633 = function(element) {
    if (!element || !element.isConnected) return false;
    if (element.getClientRects().length === 0) return false;
    var style = getComputedStyle(element);
    if (style.visibility === 'hidden' || style.visibility === 'collapse') return false;
    var rect = element.getBoundingClientRect();
    if (rect.width === 0 || rect.height === 0) return false;
    if (style.opacity === '0') return false;
    return true;
};

});

parcelRegister("kFRv0", function(module, exports) {

$parcel$export(module.exports, "initCommonHandlers", function () { return $9bb6a0dfc7d291b4$export$d387cbab91f491cd; });

var $hvZMf = parcelRequire("hvZMf");

var $LCZef = parcelRequire("LCZef");

var $jm8jg = parcelRequire("jm8jg");
var $9bb6a0dfc7d291b4$var$initSubMenuTogglesHandler = function() {
    var sideMenuToggle = document.querySelector('.side-menu .menu-toggle .menu-toggle-btn');
    sideMenuToggle === null || sideMenuToggle === void 0 ? void 0 : sideMenuToggle.addEventListener('click', function() {
        if (sideMenuToggle.classList.contains('opened')) {
            var _sideMenuToggle_ariaControlsElements;
            sideMenuToggle.classList.remove('opened');
            sideMenuToggle.ariaExpanded = 'false';
            var _sideMenuToggle_ariaControlsElements_;
            (0, $LCZef.slideUp)((_sideMenuToggle_ariaControlsElements_ = (_sideMenuToggle_ariaControlsElements = sideMenuToggle.ariaControlsElements) === null || _sideMenuToggle_ariaControlsElements === void 0 ? void 0 : _sideMenuToggle_ariaControlsElements[0]) !== null && _sideMenuToggle_ariaControlsElements_ !== void 0 ? _sideMenuToggle_ariaControlsElements_ : null, 200);
        } else {
            var _sideMenuToggle_ariaControlsElements1;
            sideMenuToggle.classList.add('opened');
            sideMenuToggle.ariaExpanded = 'true';
            var _sideMenuToggle_ariaControlsElements_1;
            (0, $LCZef.slideDown)((_sideMenuToggle_ariaControlsElements_1 = (_sideMenuToggle_ariaControlsElements1 = sideMenuToggle.ariaControlsElements) === null || _sideMenuToggle_ariaControlsElements1 === void 0 ? void 0 : _sideMenuToggle_ariaControlsElements1[0]) !== null && _sideMenuToggle_ariaControlsElements_1 !== void 0 ? _sideMenuToggle_ariaControlsElements_1 : null, 200);
        }
    });
};
var $9bb6a0dfc7d291b4$var$initSubMenuListToggleHandlers = function() {
    document.querySelectorAll('.side-menu .menu-lists .parent').forEach(function(parentListItem) {
        var toggle = parentListItem.querySelector('button');
        toggle === null || toggle === void 0 ? void 0 : toggle.addEventListener('click', function() {
            if (parentListItem.classList.contains('opened')) {
                var _toggle_ariaControlsElements;
                parentListItem.classList.remove('opened');
                toggle.ariaExpanded = 'false';
                (0, $LCZef.slideUp)((_toggle_ariaControlsElements = toggle.ariaControlsElements) === null || _toggle_ariaControlsElements === void 0 ? void 0 : _toggle_ariaControlsElements[0], 200);
            } else {
                var _toggle_ariaControlsElements1;
                parentListItem.classList.add('opened');
                toggle.ariaExpanded = 'true';
                (0, $LCZef.slideDown)((_toggle_ariaControlsElements1 = toggle.ariaControlsElements) === null || _toggle_ariaControlsElements1 === void 0 ? void 0 : _toggle_ariaControlsElements1[0], 200);
            }
        });
    });
};
var $9bb6a0dfc7d291b4$var$initBoxTabsHandler = function() {
    document.querySelectorAll('.box-tabs').forEach(function(boxTabContainer) {
        var tabs = boxTabContainer.querySelectorAll('.tabs .tab');
        tabs.forEach(function(tab) {
            var _tab_parentElement;
            if (tab !== ((_tab_parentElement = tab.parentElement) === null || _tab_parentElement === void 0 ? void 0 : _tab_parentElement.firstElementChild)) tab.style.display = 'none';
        });
        var nav = boxTabContainer.querySelector('.box-tab-nav');
        if (nav) {
            var toggles = nav === null || nav === void 0 ? void 0 : nav.querySelectorAll('a');
            toggles.forEach(function(toggle) {
                return toggle.addEventListener('click', function(event) {
                    event.preventDefault();
                    var target = document.getElementById(toggle.href);
                    toggles.forEach(function(link) {
                        return link.classList.remove('on');
                    });
                    toggle.classList.add('on');
                    tabs.forEach(function(tab) {
                        return tab.style.display = 'none';
                    });
                    (0, $LCZef.fadeIn)(target, 200);
                });
            });
        }
    });
};
var $9bb6a0dfc7d291b4$var$initChecklistHandler = function() {
    document.querySelectorAll('.list-checklist li a').forEach(function(toggle) {
        return toggle === null || toggle === void 0 ? void 0 : toggle.addEventListener('click', function(event) {
            event.preventDefault();
            toggle.classList.contains('on') ? toggle.classList.remove('on') : toggle.classList.add('on');
        });
    });
};
var $9bb6a0dfc7d291b4$var$initFilterBoxHandler = function() {
    document.querySelectorAll('.filter-box .toggle').forEach(function(toggle) {
        return toggle.addEventListener('click', function(event) {
            event.preventDefault();
            if (toggle.classList.contains('opened')) {
                toggle.classList.remove('opened');
                (0, $LCZef.slideUp)(toggle.nextElementSibling);
            } else {
                toggle.classList.add('opened');
                (0, $LCZef.slideDown)(toggle.nextElementSibling);
            }
        });
    });
};
var $9bb6a0dfc7d291b4$var$initJumpLinksHandlers = function() {
    var _document_querySelector;
    document.querySelectorAll('a.scroll-to').forEach(function(link) {
        return link.addEventListener('click', function(event) {
            var _document_querySelector;
            event.preventDefault();
            var match = link.href.match(/#[^#\/]*$/);
            if (match === null || match === void 0 ? void 0 : match[0]) (_document_querySelector = document.querySelector(match[0])) === null || _document_querySelector === void 0 ? void 0 : _document_querySelector.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        });
    });
    (_document_querySelector = document.querySelector('a.skip-to-content')) === null || _document_querySelector === void 0 ? void 0 : _document_querySelector.addEventListener('click', function(event) {
        var _document_querySelector, _document_querySelector1;
        event.preventDefault();
        (_document_querySelector = document.querySelector('#content')) === null || _document_querySelector === void 0 ? void 0 : _document_querySelector.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
        (_document_querySelector1 = document.querySelector('#content a')) === null || _document_querySelector1 === void 0 ? void 0 : _document_querySelector1.focus();
    });
};
var $9bb6a0dfc7d291b4$var$initEmbedSizingHandler = function() {
    document.querySelectorAll('.fit-embed-to-container > iframe').forEach(function(iframe) {
        var _iframe_getAttribute;
        var height = parseInt((_iframe_getAttribute = iframe.getAttribute('height')) !== null && _iframe_getAttribute !== void 0 ? _iframe_getAttribute : '0');
        var _iframe_getAttribute1;
        var width = parseInt((_iframe_getAttribute1 = iframe.getAttribute('width')) !== null && _iframe_getAttribute1 !== void 0 ? _iframe_getAttribute1 : '0');
        if (height && width) iframe.parentElement.style.paddingBottom = "".concat((height / width * 100).toFixed(2), "%");
        else iframe.parentElement.style.paddingBottom = '56.25%';
    });
};
var $9bb6a0dfc7d291b4$var$initTableHandlers = function() {
    document.querySelectorAll('.body-copy table').forEach(function(table) {
        if (!table.classList.contains('static') && !table.parentElement.classList.contains('responsive-table')) {
            var wrapper = (0, $jm8jg.createElement)('div', {
                classes: [
                    'responsive-table'
                ]
            });
            var parent = table.parentElement;
            var nextSibling = table.nextElementSibling;
            wrapper.appendChild(table);
            if (nextSibling) parent === null || parent === void 0 ? void 0 : parent.insertBefore(wrapper, nextSibling);
            else parent === null || parent === void 0 ? void 0 : parent.appendChild(wrapper);
        }
    });
    var responsiveTableContainers = document.querySelectorAll('.responsive-table');
    responsiveTableContainers.forEach(function(tableContainer) {
        return tableContainer.scrollWidth > tableContainer.offsetWidth && tableContainer.classList.add('active');
    });
    window.addEventListener('resize', function() {
        responsiveTableContainers.forEach(function(tableContainer) {
            return tableContainer.scrollWidth > tableContainer.offsetWidth ? tableContainer.classList.add('active') : tableContainer.classList.remove('active');
        });
    });
};
var $9bb6a0dfc7d291b4$var$initScrollHandler = function() {
    window.addEventListener('scroll', function() {
        var _document_getElementById, _document_getElementById1;
        return window.scrollY > 0 ? (_document_getElementById = document.getElementById('page')) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.classList.remove('top') : (_document_getElementById1 = document.getElementById('page')) === null || _document_getElementById1 === void 0 ? void 0 : _document_getElementById1.classList.add('top');
    });
};
var $9bb6a0dfc7d291b4$var$initSwitchWrapHandlers = function() {
    var tabListContainer = document.querySelector('.switch-wrap');
    var tabPanels = (0, $hvZMf._)(document.querySelectorAll('.switch-content-wrap .switch-content'));
    if (tabListContainer) {
        var tabButtons = (0, $hvZMf._)(tabListContainer.querySelectorAll('button'));
        tabListContainer.addEventListener('keydown', function(event) {
            var previousActiveTabIndex = -1;
            var newActiveTabIndex = -1;
            switch(event.key){
                case 'ArrowLeft':
                    event.preventDefault();
                    previousActiveTabIndex = tabButtons.findIndex(function(button) {
                        return button.ariaSelected === 'true';
                    });
                    newActiveTabIndex = previousActiveTabIndex - 1 >= 0 ? previousActiveTabIndex - 1 : tabButtons.length - 1;
                    resetTabButtons();
                    activateTabButton(tabButtons[newActiveTabIndex]);
                    break;
                case 'ArrowRight':
                    event.preventDefault();
                    previousActiveTabIndex = tabButtons.findIndex(function(button) {
                        return button.ariaSelected === 'true';
                    });
                    newActiveTabIndex = previousActiveTabIndex + 1 < tabButtons.length ? previousActiveTabIndex + 1 : 0;
                    resetTabButtons();
                    activateTabButton(tabButtons[newActiveTabIndex]);
                    break;
                case 'End':
                    event.preventDefault();
                    resetTabButtons();
                    activateTabButton(tabButtons[tabButtons.length - 1]);
                    break;
                case 'Home':
                    event.preventDefault();
                    resetTabButtons();
                    activateTabButton(tabButtons[0]);
                    break;
                default:
                    return;
            }
        });
        tabButtons.forEach(function(button) {
            return button.addEventListener('click', function() {
                resetTabButtons();
                activateTabButton(button);
            });
        });
        var resetTabButtons = function() {
            tabButtons.forEach(function(button) {
                button.tabIndex = -1;
                button.removeAttribute('aria-selected');
            });
        };
        var activateTabButton = function(button) {
            if (button) {
                var _button_ariaControlsElements;
                button.ariaSelected = 'true';
                button.removeAttribute('tabindex');
                button.focus();
                toggleMenu((_button_ariaControlsElements = button.ariaControlsElements) === null || _button_ariaControlsElements === void 0 ? void 0 : _button_ariaControlsElements[0]);
            }
        };
        var toggleMenu = function(menuToShow) {
            if (menuToShow) {
                var menusToHide = tabPanels.filter(function(panel) {
                    return panel.id !== menuToShow.id;
                });
                menusToHide.forEach(function(panel) {
                    return (0, $LCZef.hide)(panel);
                });
                (0, $LCZef.show)(menuToShow);
            }
        };
    }
};
var $9bb6a0dfc7d291b4$export$d387cbab91f491cd = function() {
    $9bb6a0dfc7d291b4$var$initSubMenuTogglesHandler();
    $9bb6a0dfc7d291b4$var$initSubMenuListToggleHandlers();
    $9bb6a0dfc7d291b4$var$initBoxTabsHandler();
    $9bb6a0dfc7d291b4$var$initChecklistHandler();
    $9bb6a0dfc7d291b4$var$initFilterBoxHandler();
    $9bb6a0dfc7d291b4$var$initJumpLinksHandlers();
    $9bb6a0dfc7d291b4$var$initEmbedSizingHandler();
    $9bb6a0dfc7d291b4$var$initTableHandlers();
    $9bb6a0dfc7d291b4$var$initScrollHandler();
    $9bb6a0dfc7d291b4$var$initSwitchWrapHandlers();
};

});
parcelRegister("jm8jg", function(module, exports) {

$parcel$export(module.exports, "createElement", function () { return $9a5297f5112e9cd2$export$c8a8987d4410bf2d; });

var $hvZMf = parcelRequire("hvZMf");
var $9a5297f5112e9cd2$export$c8a8987d4410bf2d = function(tagName, options) {
    var _element_classList;
    var element = document.createElement(tagName);
    if (options === null || options === void 0 ? void 0 : options.id) element.id = options.id;
    if (options === null || options === void 0 ? void 0 : options.classes) (_element_classList = element.classList).add.apply(_element_classList, (0, $hvZMf._)(options.classes));
    if ((options === null || options === void 0 ? void 0 : options.href) && 'href' in element) element.href = options.href;
    if ((options === null || options === void 0 ? void 0 : options.src) && 'src' in element) element.src = options.src;
    if (options === null || options === void 0 ? void 0 : options.style) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = Object.keys(options.style)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                if (options.style[key] !== undefined) element.style[key] = options.style[key];
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    if ((options === null || options === void 0 ? void 0 : options.type) && 'type' in element) element.type = options.type;
    if (options === null || options === void 0 ? void 0 : options.ariaControls) element.setAttribute('aria-controls', options.ariaControls);
    if ((options === null || options === void 0 ? void 0 : options.ariaHidden) !== undefined) element.ariaHidden = options.ariaHidden;
    if ((options === null || options === void 0 ? void 0 : options.ariaExpanded) !== undefined) element.ariaExpanded = options.ariaExpanded;
    if ((options === null || options === void 0 ? void 0 : options.tabIndex) !== undefined) element.tabIndex = options.tabIndex;
    if (options === null || options === void 0 ? void 0 : options.innerText) element.innerText = options.innerText;
    if ((options === null || options === void 0 ? void 0 : options.value) && 'value' in element) element.value = options.value;
    if (options === null || options === void 0 ? void 0 : options.title) element.title = options.title;
    if ((options === null || options === void 0 ? void 0 : options.alt) && 'alt' in element) element.alt = options.alt;
    if ((options === null || options === void 0 ? void 0 : options.target) && 'target' in element) element.target = options.target;
    if (options === null || options === void 0 ? void 0 : options.properties) {
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = options.properties[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var property = _step1.value;
                if (property.key && property.key in element) element[property.key] = property.value;
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                    _iterator1["return"]();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
    }
    if (options === null || options === void 0 ? void 0 : options.role) element.role = options.role;
    if (options === null || options === void 0 ? void 0 : options.ariaPosInSet) element.ariaPosInSet = options.ariaPosInSet;
    if ((options === null || options === void 0 ? void 0 : options.disabled) && 'disabled' in element) element.disabled = element.disabled;
    if (options === null || options === void 0 ? void 0 : options.children) {
        var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
        try {
            for(var _iterator2 = options.children[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                var child = _step2.value;
                if (child !== null) element.appendChild(child);
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
                    _iterator2["return"]();
                }
            } finally{
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }
    }
    var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
    if (options === null || options === void 0 ? void 0 : options.handlers) try {
        for(var _iterator3 = options.handlers[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
            var handler = _step3.value;
            element.addEventListener(handler.type, handler.listener);
        }
    } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion3 && _iterator3["return"] != null) {
                _iterator3["return"]();
            }
        } finally{
            if (_didIteratorError3) {
                throw _iteratorError3;
            }
        }
    }
    return element;
};

});


parcelRegister("eDoRc", function(module, exports) {

$parcel$export(module.exports, "initPrintHandlers", function () { return $dccbb188d489c7ee$export$3b0b98a4995a4d1f; });

var $hvZMf = parcelRequire("hvZMf");

var $jm8jg = parcelRequire("jm8jg");
var $dccbb188d489c7ee$export$3b0b98a4995a4d1f = function() {
    var createBibliography = function() {
        var contentLinks = document.querySelectorAll('.order-lg-2 a, .body-copy a, .tile a, .box-blog a');
        var excludedPrefixes = [
            '#',
            'tel:',
            'mailto:'
        ];
        var allLinks = (0, $hvZMf._)(contentLinks).reduce(function(accumulator, link) {
            var hrefAttribute = link.getAttribute('href');
            if (hrefAttribute && !excludedPrefixes.some(function(prefix) {
                return hrefAttribute === null || hrefAttribute === void 0 ? void 0 : hrefAttribute.startsWith(prefix);
            })) {
                if (hrefAttribute.startsWith('/')) hrefAttribute = "".concat(window.location).concat(hrefAttribute);
                if (!accumulator.some(function(existingUrl) {
                    return existingUrl.url === hrefAttribute;
                })) accumulator = (0, $hvZMf._)(accumulator).concat([
                    {
                        url: hrefAttribute,
                        linkText: link.innerText
                    }
                ]);
            }
            return accumulator;
        }, []);
        if (allLinks.length) {
            var pageElement = document.getElementById('page');
            pageElement === null || pageElement === void 0 ? void 0 : pageElement.appendChild((0, $jm8jg.createElement)('div', {
                id: 'PrintedBibliography',
                children: [
                    (0, $jm8jg.createElement)('h2', {
                        innerText: 'Page Links'
                    }),
                    (0, $jm8jg.createElement)('ol', {
                        children: allLinks.map(function(link) {
                            return (0, $jm8jg.createElement)('li', {
                                innerText: link.linkText ? "".concat(link.linkText, " - ").concat(link.url) : link.url
                            });
                        })
                    })
                ]
            }));
        }
    };
    var beforePrint = function() {
        var bibliography = document.getElementById('PrintedBibliography');
        if (bibliography) bibliography.style.removeProperty('display');
        else createBibliography();
    };
    var afterPrint = function() {
        var bibliography = document.getElementById('PrintedBibliography');
        if (bibliography) bibliography.style.display = 'none';
    };
    if (window.matchMedia !== undefined) {
        var mediaQueryList = window.matchMedia('print');
        mediaQueryList.addEventListener('change', function(mql) {
            return mql.matches ? beforePrint() : afterPrint;
        });
    }
    if (window.onbeforeprint !== undefined) {
        window.onbeforeprint = beforePrint;
        window.onafterprint = afterPrint;
    }
};

});

parcelRegister("6fEYs", function(module, exports) {

$parcel$export(module.exports, "initTranslationHandlers", function () { return $cbc678aa47097b69$export$f125055e8f6ba262; });

var $1P2tS = parcelRequire("1P2tS");

var $jm8jg = parcelRequire("jm8jg");
var $cbc678aa47097b69$export$f125055e8f6ba262 = function() {
    var getExistingTranslation = function() {
        var languageCookie = (0, $1P2tS.getCookie)('googtrans');
        if (languageCookie) {
            var match = languageCookie.match(/\/en\/(([a-zA-Z]*(-[a-zA-Z]*)?))/);
            return match === null || match === void 0 ? void 0 : match[1];
        }
    };
    var populateTranslateWraps = function() {
        var translateWidgetTemplate = document.getElementById('translate_widget_template');
        var translateWraps = document.querySelectorAll('.translate-wrap');
        translateWraps.forEach(function(translateWrap) {
            return (translateWidgetTemplate === null || translateWidgetTemplate === void 0 ? void 0 : translateWidgetTemplate.content) && translateWrap.appendChild(translateWidgetTemplate.content.cloneNode(true));
        });
    };
    var removeDefaultOption = function(translateSelector) {
        var _translateSelector_firstElementChild;
        if (((_translateSelector_firstElementChild = translateSelector.firstElementChild) === null || _translateSelector_firstElementChild === void 0 ? void 0 : _translateSelector_firstElementChild.innerText.toLowerCase()) === 'select language') translateSelector.removeChild(translateSelector.firstElementChild);
    };
    var insertDefaultOption = function(translateSelector) {
        var _translateSelector_firstElementChild;
        if (((_translateSelector_firstElementChild = translateSelector.firstElementChild) === null || _translateSelector_firstElementChild === void 0 ? void 0 : _translateSelector_firstElementChild.innerText.toLowerCase()) !== 'select language') translateSelector.insertBefore((0, $jm8jg.createElement)('option', {
            innerText: 'Select Language',
            value: ''
        }), translateSelector.firstElementChild);
    };
    var insertEnglishOption = function(translateSelector) {
        if (translateSelector.querySelector('option[value="en"]') === null) {
            var estonianOption = translateSelector.querySelector('option[value="et"]');
            if (estonianOption) estonianOption.after((0, $jm8jg.createElement)('option', {
                innerText: 'English',
                value: 'en'
            }));
        }
    };
    var createInContentTranslationWidget = function() {
        var pageHeading = document.querySelector('#content h1:first-of-type');
        var contentBlock = document.getElementById('content');
        if (pageHeading || contentBlock) {
            var _pageHeading_parentElement, _pageHeading_parentElement1;
            var remoteTranslateContainer = (0, $jm8jg.createElement)('div', {
                id: 'remote-translate-container',
                classes: [
                    'translate-wrap'
                ],
                tabIndex: 0,
                style: {
                    display: 'none'
                }
            });
            var contentTranslateContainer = (0, $jm8jg.createElement)('div', {
                classes: [
                    'content-translate-container'
                ]
            });
            var buttonInputContainer = (0, $jm8jg.createElement)('div', {
                classes: [
                    'translate-button-input'
                ]
            });
            var translateToggle = (0, $jm8jg.createElement)('button', {
                type: 'button',
                classes: [
                    'translate-toggle'
                ],
                ariaControls: 'remote-translate-container',
                ariaExpanded: 'false',
                handlers: [
                    {
                        type: 'focusout',
                        listener: function(event) {
                            if (!event.relatedTarget && !buttonInputContainer.contains(event.relatedTarget)) {
                                buttonInputContainer.classList.remove('active');
                                translateToggle.ariaExpanded = 'false';
                                remoteTranslateContainer.style.display = 'none';
                            }
                        }
                    }
                ],
                children: [
                    (0, $jm8jg.createElement)('i', {
                        classes: [
                            'fas',
                            'fa-globe'
                        ],
                        ariaHidden: 'true'
                    }),
                    (0, $jm8jg.createElement)('span', {
                        innerText: 'Translate This Page'
                    })
                ]
            });
            buttonInputContainer.appendChild(translateToggle);
            buttonInputContainer.appendChild(remoteTranslateContainer);
            contentTranslateContainer.appendChild(buttonInputContainer);
            pageHeading && pageHeading.nextElementSibling ? (_pageHeading_parentElement = pageHeading.parentElement) === null || _pageHeading_parentElement === void 0 ? void 0 : _pageHeading_parentElement.insertBefore(contentTranslateContainer, pageHeading.nextElementSibling) : pageHeading ? (_pageHeading_parentElement1 = pageHeading.parentElement) === null || _pageHeading_parentElement1 === void 0 ? void 0 : _pageHeading_parentElement1.append(contentTranslateContainer) : contentBlock === null || contentBlock === void 0 ? void 0 : contentBlock.insertBefore(contentTranslateContainer, contentBlock.firstElementChild);
        }
    };
    var initTranslateSelectorsSync = function() {
        var remoteTranslateSelectors = document.querySelectorAll('.remote-translate-element select');
        var nativeGoogleTranslateSelector = document.querySelector('#google_translate_element select');
        var existingTranslation = getExistingTranslation();
        remoteTranslateSelectors.forEach(function(translateSelector) {
            if (existingTranslation && existingTranslation !== 'en') {
                removeDefaultOption(translateSelector);
                insertEnglishOption(translateSelector);
                translateSelector.value = existingTranslation;
            }
            translateSelector.addEventListener('change', function(event) {
                var _event_target;
                removeDefaultOption(translateSelector);
                insertEnglishOption(translateSelector);
                if ((_event_target = event.target) === null || _event_target === void 0 ? void 0 : _event_target.value) {
                    remoteTranslateSelectors.forEach(function(remoteTranslateSelector) {
                        return remoteTranslateSelector.value = event.target.value;
                    });
                    if (nativeGoogleTranslateSelector) {
                        nativeGoogleTranslateSelector.value = event.target.value;
                        nativeGoogleTranslateSelector.dispatchEvent(new Event('change'));
                    }
                }
            });
        });
        nativeGoogleTranslateSelector === null || nativeGoogleTranslateSelector === void 0 ? void 0 : nativeGoogleTranslateSelector.addEventListener('change', function(event) {
            return Array.prototype.forEach.call(remoteTranslateSelectors, function(translateSelector) {
                var _event_target;
                if (((_event_target = event.target) === null || _event_target === void 0 ? void 0 : _event_target.value) === '') insertDefaultOption(translateSelector);
                translateSelector.value = event.target.value;
            });
        });
        new MutationObserver(function(mutationList) {
            return mutationList.forEach(function(mutation) {
                if (mutation.type === 'attributes' && !mutation.target.classList.contains('translated-rtl') && !mutation.target.classList.contains('translated-ltr')) Array.prototype.forEach.call(remoteTranslateSelectors, function(translateSelector) {
                    insertDefaultOption(translateSelector);
                    translateSelector.value = '';
                });
            });
        }).observe(document.documentElement, {
            attributeFilter: [
                'class'
            ]
        });
        var translateTitleObserver = new MutationObserver(function(mutatationList) {
            return mutatationList.forEach(function(mutation) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = mutation.addedNodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var node = _step.value;
                        var _container_firstElementChild;
                        var container = node;
                        if (container.tagName === 'DIV' && container.classList.contains('skiptranslate') && ((_container_firstElementChild = container.firstElementChild) === null || _container_firstElementChild === void 0 ? void 0 : _container_firstElementChild.tagName) === 'IFRAME' && container.firstElementChild.classList.contains('skiptranslate')) {
                            var element = container.firstElementChild;
                            if (!element.title) element.title = 'Language Translate Widget';
                            translateTitleObserver.disconnect();
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            });
        });
        translateTitleObserver.observe(document.documentElement, {
            childList: true,
            subtree: true
        });
    };
    var initTranslateTogglesHandler = function() {
        var translateToggles = document.querySelectorAll('.translate-toggle');
        translateToggles.forEach(function(toggle) {
            var _toggle_ariaControlsElements;
            if ((_toggle_ariaControlsElements = toggle.ariaControlsElements) === null || _toggle_ariaControlsElements === void 0 ? void 0 : _toggle_ariaControlsElements[0]) {
                toggle.addEventListener('click', function() {
                    if (toggle.ariaExpanded === 'true') {
                        var _toggle_ariaControlsElements, _toggle_parentElement;
                        toggle.ariaExpanded = 'false';
                        if ((_toggle_ariaControlsElements = toggle.ariaControlsElements) === null || _toggle_ariaControlsElements === void 0 ? void 0 : _toggle_ariaControlsElements[0]) toggle.ariaControlsElements[0].style.display = 'none';
                        if ((_toggle_parentElement = toggle.parentElement) === null || _toggle_parentElement === void 0 ? void 0 : _toggle_parentElement.classList.contains('translate-button-input')) toggle.parentElement.classList.remove('active');
                    } else {
                        var _toggle_ariaControlsElements1, _toggle_parentElement1;
                        toggle.ariaExpanded = 'true';
                        if ((_toggle_ariaControlsElements1 = toggle.ariaControlsElements) === null || _toggle_ariaControlsElements1 === void 0 ? void 0 : _toggle_ariaControlsElements1[0]) toggle.ariaControlsElements[0].style.removeProperty('display');
                        if ((_toggle_parentElement1 = toggle.parentElement) === null || _toggle_parentElement1 === void 0 ? void 0 : _toggle_parentElement1.classList.contains('translate-button-input')) toggle.parentElement.classList.add('active');
                    }
                });
                if (toggle.classList.contains('desktop-translate-toggle')) {
                    var pageHeader = document.querySelector('header .header-top') ? document.querySelector('header .header-top') : document.querySelector('header');
                    if (pageHeader) {
                        pageHeader.addEventListener('mouseleave', function() {
                            var _toggle_ariaControlsElements, _toggle_parentElement;
                            toggle.ariaExpanded = 'false';
                            if ((_toggle_ariaControlsElements = toggle.ariaControlsElements) === null || _toggle_ariaControlsElements === void 0 ? void 0 : _toggle_ariaControlsElements[0]) toggle.ariaControlsElements[0].style.display = 'none';
                            if ((_toggle_parentElement = toggle.parentElement) === null || _toggle_parentElement === void 0 ? void 0 : _toggle_parentElement.classList.contains('translate-button-input')) toggle.parentElement.classList.remove('active');
                        });
                        pageHeader.addEventListener('focusout', function(event) {
                            if (!event.relatedTarget || !pageHeader.contains(event.relatedTarget)) {
                                var _toggle_ariaControlsElements, _toggle_parentElement;
                                toggle.ariaExpanded = 'false';
                                if ((_toggle_ariaControlsElements = toggle.ariaControlsElements) === null || _toggle_ariaControlsElements === void 0 ? void 0 : _toggle_ariaControlsElements[0]) toggle.ariaControlsElements[0].style.display = 'none';
                                if ((_toggle_parentElement = toggle.parentElement) === null || _toggle_parentElement === void 0 ? void 0 : _toggle_parentElement.classList.contains('translate-button-input')) toggle.parentElement.classList.remove('active');
                            }
                        });
                    }
                }
            }
        });
    };
    window.googleTranslateElementInit = function() {
        new window.google.translate.TranslateElement({
            pageLanguage: 'en'
        }, 'google_translate_element');
        if (document.body.classList.contains('t-widget')) createInContentTranslationWidget();
        populateTranslateWraps();
        initTranslateSelectorsSync();
        initTranslateTogglesHandler();
    };
};

});
parcelRegister("1P2tS", function(module, exports) {

$parcel$export(module.exports, "getCookie", function () { return $9a0b725451b84148$export$4be65e66cfa2648a; });
$parcel$export(module.exports, "deleteCookie", function () { return $9a0b725451b84148$export$b43e45590305ffaa; });
var $9a0b725451b84148$export$4be65e66cfa2648a = function(cookieName) {
    var _document_cookie_split_map_find;
    return (_document_cookie_split_map_find = document.cookie.split(';').map(function(cookie) {
        return cookie.trim().split('=');
    }).find(function(cookie) {
        return (cookie === null || cookie === void 0 ? void 0 : cookie[0]) === cookieName;
    })) === null || _document_cookie_split_map_find === void 0 ? void 0 : _document_cookie_split_map_find[1];
};
var $9a0b725451b84148$export$96746799f34533a4 = function(cookieName, cookieValue) {
    var maxAge = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 2592000, sameSite = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 'Strict', path = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : '/';
    document.cookie = "".concat(cookieName, "=").concat(cookieValue, ";Max-Age=").concat(maxAge, ";SameSite=").concat(sameSite, ";Path=").concat(path);
};
var $9a0b725451b84148$export$b43e45590305ffaa = function(cookieName) {
    var path = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : '/';
    document.cookie = "".concat(cookieName, "=; Path=").concat(path, "; Expires=Thu, 01 Jan 1970 00:00:01 GMT;");
};

});



var $hvZMf = parcelRequire("hvZMf");

var $LCZef = parcelRequire("LCZef");

var $kFRv0 = parcelRequire("kFRv0");

var $eDoRc = parcelRequire("eDoRc");

var $6fEYs = parcelRequire("6fEYs");
var $baf8384e62733ba5$var$searchMenuToggle = document.querySelector('header .toggle-search');
var $baf8384e62733ba5$var$mobileSideMenuToggle = document.querySelector('header .toggle-side-menu');
var $baf8384e62733ba5$var$dropdownContainer = document.querySelector('.dropdowns');
var $baf8384e62733ba5$var$dropdowns = document.querySelectorAll('.dropdowns .dropdown');
var $baf8384e62733ba5$var$mobileSearch = document.getElementById('dropdown-search');
var $baf8384e62733ba5$var$sideMenuWrap = document.querySelector('header .side-menu-wrap');
var $baf8384e62733ba5$var$initMenuToggles = function() {
    $baf8384e62733ba5$var$mobileSideMenuToggle === null || $baf8384e62733ba5$var$mobileSideMenuToggle === void 0 ? void 0 : $baf8384e62733ba5$var$mobileSideMenuToggle.addEventListener('click', function() {
        if ($baf8384e62733ba5$var$mobileSideMenuToggle.classList.contains('opened')) {
            $baf8384e62733ba5$var$mobileSideMenuToggle.classList.remove('opened');
            $baf8384e62733ba5$var$mobileSideMenuToggle.ariaExpanded = 'false';
            (0, $LCZef.fadeOut)($baf8384e62733ba5$var$sideMenuWrap, 200, {
                callback: function() {
                    document.documentElement.classList.remove('behind');
                    $baf8384e62733ba5$var$mobileSideMenuToggle.focus();
                }
            });
            (0, $LCZef.fadeOut)($baf8384e62733ba5$var$dropdownContainer, 200, {
                removeClasses: [
                    'opened'
                ]
            });
        } else {
            $baf8384e62733ba5$var$mobileSideMenuToggle.classList.add('opened');
            $baf8384e62733ba5$var$mobileSideMenuToggle.ariaExpanded = 'true';
            document.documentElement.classList.add('behind');
            if ($baf8384e62733ba5$var$searchMenuToggle === null || $baf8384e62733ba5$var$searchMenuToggle === void 0 ? void 0 : $baf8384e62733ba5$var$searchMenuToggle.classList.contains('opened')) {
                $baf8384e62733ba5$var$searchMenuToggle.classList.remove('opened');
                $baf8384e62733ba5$var$searchMenuToggle.ariaExpanded = 'false';
                (0, $LCZef.fadeOut)($baf8384e62733ba5$var$mobileSearch, 200, {
                    callback: function() {
                        return (0, $LCZef.fadeIn)($baf8384e62733ba5$var$sideMenuWrap, 200, {
                            callback: function() {
                                var _sideMenuWrap_querySelector;
                                (0, $LCZef.hide)($baf8384e62733ba5$var$dropdownContainer, {
                                    removeClasses: [
                                        'opened'
                                    ]
                                });
                                $baf8384e62733ba5$var$sideMenuWrap === null || $baf8384e62733ba5$var$sideMenuWrap === void 0 ? void 0 : (_sideMenuWrap_querySelector = $baf8384e62733ba5$var$sideMenuWrap.querySelector('a')) === null || _sideMenuWrap_querySelector === void 0 ? void 0 : _sideMenuWrap_querySelector.focus();
                            }
                        });
                    }
                });
            } else (0, $LCZef.fadeIn)($baf8384e62733ba5$var$sideMenuWrap, 200, {
                callback: function() {
                    var _sideMenuWrap_querySelector;
                    return $baf8384e62733ba5$var$sideMenuWrap === null || $baf8384e62733ba5$var$sideMenuWrap === void 0 ? void 0 : (_sideMenuWrap_querySelector = $baf8384e62733ba5$var$sideMenuWrap.querySelector('a')) === null || _sideMenuWrap_querySelector === void 0 ? void 0 : _sideMenuWrap_querySelector.focus();
                }
            });
        }
    });
    $baf8384e62733ba5$var$searchMenuToggle === null || $baf8384e62733ba5$var$searchMenuToggle === void 0 ? void 0 : $baf8384e62733ba5$var$searchMenuToggle.addEventListener('click', function() {
        if ($baf8384e62733ba5$var$searchMenuToggle.classList.contains('opened')) {
            $baf8384e62733ba5$var$searchMenuToggle.classList.remove('opened');
            $baf8384e62733ba5$var$searchMenuToggle.ariaExpanded = 'false';
            (0, $LCZef.fadeOut)($baf8384e62733ba5$var$mobileSearch, 200, {
                callback: function() {
                    document.documentElement.classList.remove('behind');
                    $baf8384e62733ba5$var$searchMenuToggle.focus();
                }
            });
            (0, $LCZef.fadeOut)($baf8384e62733ba5$var$dropdownContainer, 200, {
                removeClasses: [
                    'opened'
                ]
            });
        } else {
            $baf8384e62733ba5$var$searchMenuToggle.classList.add('opened');
            $baf8384e62733ba5$var$searchMenuToggle.ariaExpanded = 'true';
            document.documentElement.classList.add('behind');
            if ($baf8384e62733ba5$var$mobileSideMenuToggle === null || $baf8384e62733ba5$var$mobileSideMenuToggle === void 0 ? void 0 : $baf8384e62733ba5$var$mobileSideMenuToggle.classList.contains('opened')) {
                $baf8384e62733ba5$var$mobileSideMenuToggle.classList.remove('opened');
                $baf8384e62733ba5$var$mobileSideMenuToggle.ariaExpanded = 'false';
                (0, $LCZef.show)($baf8384e62733ba5$var$dropdownContainer, {
                    addClasses: [
                        'opened'
                    ]
                });
                (0, $LCZef.fadeOut)($baf8384e62733ba5$var$sideMenuWrap, 200, {
                    callback: function() {
                        return (0, $LCZef.fadeIn)($baf8384e62733ba5$var$mobileSearch, 200, {
                            callback: function() {
                                var _document_getElementById;
                                return (_document_getElementById = document.getElementById('search-terms-mobile')) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.focus();
                            }
                        });
                    }
                });
            } else {
                $baf8384e62733ba5$var$dropdowns.forEach(function(dropdown) {
                    return (0, $LCZef.hide)(dropdown);
                });
                (0, $LCZef.fadeIn)($baf8384e62733ba5$var$dropdownContainer, 200, {
                    addClasses: [
                        'opened'
                    ]
                });
                (0, $LCZef.fadeIn)($baf8384e62733ba5$var$mobileSearch, 200, {
                    callback: function() {
                        var _document_getElementById;
                        return (_document_getElementById = document.getElementById('search-terms-mobile')) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.focus();
                    }
                });
            }
        }
    });
};
var $baf8384e62733ba5$var$resetMobileMenus = function() {
    document.documentElement.classList.remove('behind');
    document.body.classList.remove('behind');
    if ($baf8384e62733ba5$var$mobileSideMenuToggle) {
        $baf8384e62733ba5$var$mobileSideMenuToggle.classList.remove('opened');
        $baf8384e62733ba5$var$mobileSideMenuToggle.ariaExpanded = 'false';
    }
    if ($baf8384e62733ba5$var$searchMenuToggle) {
        $baf8384e62733ba5$var$searchMenuToggle.classList.remove('opened');
        $baf8384e62733ba5$var$searchMenuToggle.ariaExpanded = 'false';
    }
    (0, $LCZef.hide)($baf8384e62733ba5$var$sideMenuWrap);
    $baf8384e62733ba5$var$dropdowns.forEach(function(dropdown) {
        return (0, $LCZef.hide)(dropdown);
    });
    (0, $LCZef.hide)($baf8384e62733ba5$var$dropdownContainer, {
        removeClasses: [
            'opened'
        ]
    });
};
var $baf8384e62733ba5$var$initMobileMenuResetOnResizeHandler = function() {
    window.addEventListener('resize', function() {
        return window.innerWidth > 991 && $baf8384e62733ba5$var$resetMobileMenus();
    });
};
var $baf8384e62733ba5$var$initTopNavDisplayOnFocus = function(topNavLinks) {
    topNavLinks.forEach(function(topNavLink) {
        return topNavLink.addEventListener('focus', function() {
            if (topNavLink.nextElementSibling && !topNavLink.nextElementSibling.classList.contains('nav-visible')) topNavLink.nextElementSibling.classList.add('nav-visible');
        });
    });
};
var $baf8384e62733ba5$var$initTopNavHideOnBlur = function(topNavLinks) {
    topNavLinks.forEach(function(topNavLink) {
        return topNavLink.addEventListener('blur', function(event) {
            var _topNavLink_parentElement;
            var currentNavLinks = (_topNavLink_parentElement = topNavLink.parentElement) === null || _topNavLink_parentElement === void 0 ? void 0 : _topNavLink_parentElement.querySelectorAll('a');
            if (topNavLink.nextElementSibling && currentNavLinks && !(0, $hvZMf._)(currentNavLinks).includes(event.relatedTarget)) topNavLink.nextElementSibling.classList.remove('nav-visible');
        });
    });
};
var $baf8384e62733ba5$var$initTopNavKeyboardNavigation = function(topNavLinks) {
    topNavLinks.forEach(function(topNavLink) {
        topNavLink.addEventListener('keydown', function(event) {
            var _topNavLink_parentElement;
            var currentNavLinks = (_topNavLink_parentElement = topNavLink.parentElement) === null || _topNavLink_parentElement === void 0 ? void 0 : _topNavLink_parentElement.querySelectorAll('a');
            if (currentNavLinks) {
                var currentMainNavIndex = (0, $hvZMf._)(topNavLinks).indexOf(topNavLink);
                switch(event.key){
                    case 'ArrowUp':
                        event.preventDefault();
                        if (currentNavLinks.length > 1) {
                            var _topNavLink_nextElementSibling;
                            if ((_topNavLink_nextElementSibling = topNavLink.nextElementSibling) === null || _topNavLink_nextElementSibling === void 0 ? void 0 : _topNavLink_nextElementSibling.classList.contains('nav-visible')) topNavLink.nextElementSibling.classList.add('nav-visible');
                            currentNavLinks[currentNavLinks.length - 1].focus();
                        }
                        break;
                    case 'ArrowDown':
                        event.preventDefault();
                        if (currentNavLinks.length > 1) {
                            var _topNavLink_nextElementSibling1;
                            if ((_topNavLink_nextElementSibling1 = topNavLink.nextElementSibling) === null || _topNavLink_nextElementSibling1 === void 0 ? void 0 : _topNavLink_nextElementSibling1.classList.contains('nav-visible')) topNavLink.nextElementSibling.classList.add('nav-visible');
                            currentNavLinks[1].focus();
                        }
                        break;
                    case 'ArrowLeft':
                        event.preventDefault();
                        if (topNavLinks[currentMainNavIndex - 1]) topNavLinks[currentMainNavIndex - 1].focus();
                        else if (topNavLinks[topNavLinks.length - 1]) topNavLinks[topNavLinks.length - 1].focus();
                        break;
                    case 'ArrowRight':
                        event.preventDefault();
                        if (topNavLinks[currentMainNavIndex + 1]) topNavLinks[currentMainNavIndex + 1].focus();
                        else if (topNavLinks[0]) topNavLinks[0].focus();
                        break;
                    case 'Home':
                        event.preventDefault();
                        if (topNavLinks[0]) topNavLinks[0].focus();
                        break;
                    case 'End':
                        event.preventDefault();
                        if (topNavLinks[topNavLinks.length - 1]) topNavLinks[topNavLinks.length - 1].focus();
                        break;
                    case 'Escape':
                        if (topNavLink.nextElementSibling) topNavLink.nextElementSibling.classList.remove('nav-visible');
                        break;
                    default:
                        break;
                }
            }
        });
        if (topNavLink.nextElementSibling) topNavLink.nextElementSibling.querySelectorAll('a').forEach(function(childLink) {
            childLink.addEventListener('blur', function(event) {
                return document.querySelectorAll('.header-nav .links > li').forEach(function(headerMenu) {
                    var _topNavLink_nextElementSibling;
                    console.log("Contains Target: ".concat(headerMenu.contains(childLink)));
                    console.log("Does Not Contain RelatedTarget: ".concat(!headerMenu.contains(event.relatedTarget)));
                    if (event.target && event.relatedTarget && headerMenu.contains(childLink) && !headerMenu.contains(event.relatedTarget)) (_topNavLink_nextElementSibling = topNavLink.nextElementSibling) === null || _topNavLink_nextElementSibling === void 0 ? void 0 : _topNavLink_nextElementSibling.classList.remove('nav-visible');
                });
            });
            childLink.addEventListener('keydown', function(event) {
                if (topNavLink.parentElement) {
                    var _topNavLink_parentElement;
                    var currentNavLinks = (_topNavLink_parentElement = topNavLink.parentElement) === null || _topNavLink_parentElement === void 0 ? void 0 : _topNavLink_parentElement.querySelectorAll('a');
                    var currentFocusIndex = (0, $hvZMf._)(currentNavLinks).indexOf(childLink);
                    var currentMainNavIndex = (0, $hvZMf._)(topNavLinks).indexOf(topNavLink);
                    switch(event.key){
                        case 'ArrowUp':
                            event.preventDefault();
                            if (currentNavLinks[currentFocusIndex - 1]) currentNavLinks[currentFocusIndex - 1].focus();
                            else if (currentNavLinks[currentNavLinks.length - 1]) currentNavLinks[currentNavLinks.length - 1].focus();
                            break;
                        case 'ArrowDown':
                            event.preventDefault();
                            if (currentNavLinks[currentFocusIndex + 1]) currentNavLinks[currentFocusIndex + 1].focus();
                            else if (currentNavLinks[0]) currentNavLinks[0].focus();
                            break;
                        case 'ArrowLeft':
                            if (currentMainNavIndex !== undefined && currentMainNavIndex !== -1 && topNavLinks[currentMainNavIndex - 1]) topNavLinks[currentMainNavIndex - 1].focus();
                            else if (topNavLinks[topNavLinks.length - 1]) topNavLinks[topNavLinks.length - 1].focus();
                            break;
                        case 'ArrowRight':
                            if (currentMainNavIndex !== undefined && currentMainNavIndex !== -1 && topNavLinks[currentMainNavIndex + 1]) topNavLinks[currentMainNavIndex + 1].focus();
                            else if (topNavLinks[0]) topNavLinks[0].focus();
                            break;
                        case 'Home':
                            event.preventDefault();
                            if (currentNavLinks[1]) currentNavLinks[1].focus();
                            break;
                        case 'End':
                            event.preventDefault();
                            if (currentNavLinks[currentNavLinks.length - 1]) currentNavLinks[currentNavLinks.length - 1].focus();
                            break;
                        case 'Escape':
                            event.preventDefault();
                            if (currentNavLinks[0]) {
                                currentNavLinks[0].focus();
                                setTimeout(function() {
                                    var _topNavLink_parentElement;
                                    return (_topNavLink_parentElement = topNavLink.parentElement) === null || _topNavLink_parentElement === void 0 ? void 0 : _topNavLink_parentElement.classList.remove('nav-visible');
                                }, 0);
                            }
                            break;
                        default:
                            break;
                    }
                }
            });
        });
    });
};
var $baf8384e62733ba5$var$fadeOutMobileMenus = function() {
    var focusElement = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    document.documentElement.classList.remove('behind');
    document.body.classList.remove('behind');
    if ($baf8384e62733ba5$var$mobileSideMenuToggle) {
        $baf8384e62733ba5$var$mobileSideMenuToggle.classList.remove('opened');
        $baf8384e62733ba5$var$mobileSideMenuToggle.ariaExpanded = 'false';
    }
    if ($baf8384e62733ba5$var$searchMenuToggle) {
        $baf8384e62733ba5$var$searchMenuToggle.classList.remove('opened');
        $baf8384e62733ba5$var$searchMenuToggle.ariaExpanded = 'false';
    }
    (0, $LCZef.fadeOut)($baf8384e62733ba5$var$sideMenuWrap, 200);
    $baf8384e62733ba5$var$dropdowns.forEach(function(dropdown) {
        return (0, $LCZef.fadeOut)(dropdown, 200);
    });
    (0, $LCZef.fadeOut)($baf8384e62733ba5$var$dropdownContainer, 200, {
        callback: function() {
            $baf8384e62733ba5$var$dropdownContainer === null || $baf8384e62733ba5$var$dropdownContainer === void 0 ? void 0 : $baf8384e62733ba5$var$dropdownContainer.classList.remove('opened');
            focusElement === null || focusElement === void 0 ? void 0 : focusElement.focus();
        }
    });
};
var $baf8384e62733ba5$var$initDropdownToggleHandlers = function() {
    // Desktop Toggles
    var desktopDropdownsToggles = document.querySelectorAll('header .link-site button');
    desktopDropdownsToggles.forEach(function(button) {
        return button.addEventListener('click', function() {
            var _button_ariaControlsElements;
            button.ariaExpanded = 'true';
            document.body.classList.add('behind');
            (0, $LCZef.hide)($baf8384e62733ba5$var$mobileSearch);
            (0, $LCZef.show)($baf8384e62733ba5$var$dropdownContainer, {
                addClasses: [
                    'opened'
                ]
            });
            var controlledDropdown = (_button_ariaControlsElements = button.ariaControlsElements) === null || _button_ariaControlsElements === void 0 ? void 0 : _button_ariaControlsElements[0];
            (0, $LCZef.fadeIn)(controlledDropdown, 300, {
                callback: function() {
                    var _controlledDropdown_querySelector;
                    return controlledDropdown === null || controlledDropdown === void 0 ? void 0 : (_controlledDropdown_querySelector = controlledDropdown.querySelector('.close-dropdowns')) === null || _controlledDropdown_querySelector === void 0 ? void 0 : _controlledDropdown_querySelector.focus();
                }
            });
        });
    });
    // Close Toggles
    document.querySelectorAll('.dropdowns .close-dropdowns').forEach(function(button) {
        return button.addEventListener('click', function() {
            desktopDropdownsToggles.forEach(function(toggle) {
                return toggle.ariaExpanded = 'false';
            });
            $baf8384e62733ba5$var$fadeOutMobileMenus();
        });
    });
};
var $baf8384e62733ba5$var$initDropdownFocusTraps = function() {
    $baf8384e62733ba5$var$dropdowns.forEach(function(dropdown) {
        var _dropdown_querySelector;
        (_dropdown_querySelector = dropdown.querySelector('.close-dropdowns')) === null || _dropdown_querySelector === void 0 ? void 0 : _dropdown_querySelector.addEventListener('keydown', function(event) {
            if (event.key === 'Tab' && event.shiftKey) {
                var _findLast;
                event.preventDefault();
                var targets = document.querySelectorAll('a, button, input');
                (_findLast = (0, $hvZMf._)(targets).findLast(function(target) {
                    return (0, $LCZef.isVisible)(target);
                })) === null || _findLast === void 0 ? void 0 : _findLast.focus();
            }
        });
        dropdown.addEventListener('focusout', function(event) {
            var _dropdown_querySelector;
            if (!event.relatedTarget || !dropdown.contains(event.relatedTarget)) (_dropdown_querySelector = dropdown.querySelector('.close-dropdowns')) === null || _dropdown_querySelector === void 0 ? void 0 : _dropdown_querySelector.focus();
        });
        dropdown.addEventListener('keydown', function(event) {
            var targets = document.querySelectorAll('a, button, input');
            var lastVisible = (0, $hvZMf._)(targets).findLast(function(target) {
                return (0, $LCZef.isVisible)(target);
            });
            if (event.key === 'Tab' && !event.shiftKey && event.target === lastVisible) {
                var _targets_;
                event.preventDefault();
                (_targets_ = targets[0]) === null || _targets_ === void 0 ? void 0 : _targets_.focus();
            } else if (event.key == 'Escape') {
                event.preventDefault();
                $baf8384e62733ba5$var$fadeOutMobileMenus(document.querySelector("button[aria-controls=".concat(dropdown.id)));
            }
        });
    });
    $baf8384e62733ba5$var$mobileSideMenuToggle === null || $baf8384e62733ba5$var$mobileSideMenuToggle === void 0 ? void 0 : $baf8384e62733ba5$var$mobileSideMenuToggle.addEventListener('keydown', function(event) {
        if (event.key === 'Tab' && event.shiftKey) {
            if ((0, $LCZef.isVisible)($baf8384e62733ba5$var$dropdownContainer)) {
                var _findLast;
                event.preventDefault();
                var currentTargets = $baf8384e62733ba5$var$dropdownContainer === null || $baf8384e62733ba5$var$dropdownContainer === void 0 ? void 0 : $baf8384e62733ba5$var$dropdownContainer.querySelectorAll('a, button, input');
                (_findLast = (0, $hvZMf._)(currentTargets).findLast(function(target) {
                    return (0, $LCZef.isVisible)(target);
                })) === null || _findLast === void 0 ? void 0 : _findLast.focus();
            } else if ((0, $LCZef.isVisible)($baf8384e62733ba5$var$sideMenuWrap === null || $baf8384e62733ba5$var$sideMenuWrap === void 0 ? void 0 : $baf8384e62733ba5$var$sideMenuWrap.querySelector('.menu-lists'))) {
                var _findLast1;
                event.preventDefault();
                var currentTargets1 = $baf8384e62733ba5$var$sideMenuWrap === null || $baf8384e62733ba5$var$sideMenuWrap === void 0 ? void 0 : $baf8384e62733ba5$var$sideMenuWrap.querySelectorAll('a, button, input');
                (_findLast1 = (0, $hvZMf._)(currentTargets1).findLast(function(target) {
                    return (0, $LCZef.isVisible)(target);
                })) === null || _findLast1 === void 0 ? void 0 : _findLast1.focus();
            }
        } else if (event.key === 'Escape' && ((0, $LCZef.isVisible)($baf8384e62733ba5$var$dropdownContainer) || (0, $LCZef.isVisible)($baf8384e62733ba5$var$sideMenuWrap === null || $baf8384e62733ba5$var$sideMenuWrap === void 0 ? void 0 : $baf8384e62733ba5$var$sideMenuWrap.querySelector('.menu-lists')))) $baf8384e62733ba5$var$fadeOutMobileMenus();
    });
    $baf8384e62733ba5$var$searchMenuToggle === null || $baf8384e62733ba5$var$searchMenuToggle === void 0 ? void 0 : $baf8384e62733ba5$var$searchMenuToggle.addEventListener('keydown', function(event) {
        if (event.key === 'Tab' && !event.shiftKey) {
            if ((0, $LCZef.isVisible)($baf8384e62733ba5$var$dropdownContainer)) {
                var _find;
                event.preventDefault();
                var currentTargets = $baf8384e62733ba5$var$dropdownContainer === null || $baf8384e62733ba5$var$dropdownContainer === void 0 ? void 0 : $baf8384e62733ba5$var$dropdownContainer.querySelectorAll('a, button, input');
                (_find = (0, $hvZMf._)(currentTargets).find(function(target) {
                    return (0, $LCZef.isVisible)(target);
                })) === null || _find === void 0 ? void 0 : _find.focus();
            } else if ((0, $LCZef.isVisible)($baf8384e62733ba5$var$sideMenuWrap === null || $baf8384e62733ba5$var$sideMenuWrap === void 0 ? void 0 : $baf8384e62733ba5$var$sideMenuWrap.querySelector('.menu-lists'))) {
                var _find1;
                event.preventDefault();
                var currentTargets1 = $baf8384e62733ba5$var$sideMenuWrap === null || $baf8384e62733ba5$var$sideMenuWrap === void 0 ? void 0 : $baf8384e62733ba5$var$sideMenuWrap.querySelectorAll('a, button, input');
                (_find1 = (0, $hvZMf._)(currentTargets1).find(function(target) {
                    return (0, $LCZef.isVisible)(target);
                })) === null || _find1 === void 0 ? void 0 : _find1.focus();
            }
        } else if (event.key === 'Escape' && ((0, $LCZef.isVisible)($baf8384e62733ba5$var$dropdownContainer) || (0, $LCZef.isVisible)($baf8384e62733ba5$var$sideMenuWrap === null || $baf8384e62733ba5$var$sideMenuWrap === void 0 ? void 0 : $baf8384e62733ba5$var$sideMenuWrap.querySelector('.menu-lists')))) $baf8384e62733ba5$var$fadeOutMobileMenus();
    });
    $baf8384e62733ba5$var$sideMenuWrap === null || $baf8384e62733ba5$var$sideMenuWrap === void 0 ? void 0 : $baf8384e62733ba5$var$sideMenuWrap.addEventListener('keydown', function(event) {
        if ($baf8384e62733ba5$var$mobileSideMenuToggle === null || $baf8384e62733ba5$var$mobileSideMenuToggle === void 0 ? void 0 : $baf8384e62733ba5$var$mobileSideMenuToggle.classList.contains('opened')) {
            if (event.key === 'Tab' && !event.shiftKey) {
                var currentTargets = $baf8384e62733ba5$var$sideMenuWrap.querySelectorAll('a, button, input');
                var lastVisible = (0, $hvZMf._)(currentTargets).findLast(function(target) {
                    return (0, $LCZef.isVisible)(target);
                });
                if (event.target === lastVisible) {
                    event.preventDefault();
                    $baf8384e62733ba5$var$mobileSideMenuToggle.focus();
                }
            } else if (event.key === 'Escape') $baf8384e62733ba5$var$fadeOutMobileMenus($baf8384e62733ba5$var$mobileSideMenuToggle);
        }
    });
    $baf8384e62733ba5$var$mobileSearch === null || $baf8384e62733ba5$var$mobileSearch === void 0 ? void 0 : $baf8384e62733ba5$var$mobileSearch.addEventListener('keydown', function(event) {
        if ((0, $LCZef.isVisible)($baf8384e62733ba5$var$mobileSearch)) {
            if (event.key === 'Tab') {
                var currentTargets = $baf8384e62733ba5$var$mobileSearch.querySelectorAll('a, button, input');
                var lastVisible = (0, $hvZMf._)(currentTargets).findLast(function(target) {
                    return (0, $LCZef.isVisible)(target);
                });
                var firstVisible = (0, $hvZMf._)(currentTargets).find(function(target) {
                    return (0, $LCZef.isVisible)(target);
                });
                if (event.shiftKey && event.target === firstVisible) {
                    event.preventDefault();
                    $baf8384e62733ba5$var$searchMenuToggle === null || $baf8384e62733ba5$var$searchMenuToggle === void 0 ? void 0 : $baf8384e62733ba5$var$searchMenuToggle.focus();
                } else if (!event.shiftKey && event.target === lastVisible) {
                    event.preventDefault();
                    $baf8384e62733ba5$var$mobileSideMenuToggle === null || $baf8384e62733ba5$var$mobileSideMenuToggle === void 0 ? void 0 : $baf8384e62733ba5$var$mobileSideMenuToggle.focus();
                }
            } else if (event.key === 'Escape') $baf8384e62733ba5$var$fadeOutMobileMenus($baf8384e62733ba5$var$searchMenuToggle);
        }
    });
};
var $baf8384e62733ba5$var$initTopNavigationHandlers = function() {
    var topNavLinks = document.querySelectorAll(".header-nav .links > li > a");
    $baf8384e62733ba5$var$initTopNavDisplayOnFocus(topNavLinks);
    $baf8384e62733ba5$var$initTopNavHideOnBlur(topNavLinks);
    $baf8384e62733ba5$var$initTopNavKeyboardNavigation(topNavLinks);
};
var $baf8384e62733ba5$var$initMobileKeyboardNavigationHandlers = function() {};
$baf8384e62733ba5$var$initMenuToggles();
$baf8384e62733ba5$var$initMobileMenuResetOnResizeHandler();
$baf8384e62733ba5$var$initDropdownToggleHandlers();
$baf8384e62733ba5$var$initDropdownFocusTraps();
$baf8384e62733ba5$var$initTopNavigationHandlers();
(0, $kFRv0.initCommonHandlers)();
(0, $6fEYs.initTranslationHandlers)();
(0, $eDoRc.initPrintHandlers)();
$baf8384e62733ba5$var$initMobileKeyboardNavigationHandlers();

})();
//# sourceMappingURL=Microsite.js.map
